import { productData } from '@/lib/api/product-data-client'
import { reportError } from '@/spa/sentry'

export const ACCOUNTING_PAID_ORDER_CACHE_KEY = 'accounting-paid-order'

export async function fetchHasPaidAccountingOrder(): Promise<boolean> {
  try {
    // The Worker's GET /api/customer/orders answers the `{ success, data }`
    // envelope (apps/api/src/orders/routes.ts); `productData()`
    // unwraps `data` and throws on a non-2xx response, so there is no manual
    // `response.ok` check left to do here.
    const data = await productData<{ exists: boolean }>('/api/customer/orders?type=accounting&status=paid')
    return data.exists === true
  } catch (error) {
    reportError(error, { tags: { operation: 'check_accounting_order' } })
    throw error
  }
}
